import { Injectable } from '@angular/core';
import { NotificationsCenterMappingStore } from './notifications-center-mapping.store';
import { mapTo, tap } from 'rxjs/operators';
import { NotificationMappingModel } from './models/notifications-center-mapping.model';
import { ApiService } from '../../../shared/services/core/api.service';
import { lowerCaseKeys } from '../../../shared/services/core/lowercasekeys.service';

@Injectable({ providedIn: 'root' })
export class NotificationsCenterMappingService {
  constructor(private notificationsCenterMappingStore: NotificationsCenterMappingStore, private api: ApiService) {}

  /**
   * Retrieve all of the notification mappings
   */
  fetchNotificationMappings() {
    const request$ = this.api.get<NotificationMappingModel>('notificationscenter/mappings').pipe(
      tap((mappings) => {
        this.notificationsCenterMappingStore.set(lowerCaseKeys(mappings));
      }),
      mapTo(null)
    );
    return request$;
  }
}
